export default [{
  name: 'hotelList',
  method: 'post',
  desc: '酒店列表查询',
  path: '/obt/hotel/gn/shopping/hotelList',
  params: {
    singaZhid: '', // singa平台账号id
    platZhid: '', // 平台账号ID
    roomBedType: '', // 床型 0 大床房 1单床房 2双人床房 3 多人床房
    zcfs: '', // 早餐份数 0 含早餐 1单人早餐 2双人早餐 取BDC
    brandIds: '', // 品牌id，多个以逗号隔开
    businessZone: '', // 商圈id，searchType=2时，必传
    businessZoneName: '',
    checkInDate: '', // 入住日期：yyyy-mm-dd
    checkOutDate: '', // 离店日期：yyyy-mm-dd
    cityId: '', // 城市id
    corpId: '', // 企业id
    distance: 3, // 离指定经纬度距离（单位：公里）。默认3公里
    district: '', // 行政区id，searchType=1时，必传
    districtName: '',
    exclude: 0, // 为1 并且 jdids不为空，表示排除这些jdids的其他酒店；默认为0
    jdType: 1, // 酒店类型，0全部，1是可售酒店,2是签约,10是热门。默认1
    jdids: '', // 酒店id，多个酒店id用英文逗号隔开
    keywords: '', // 酒店名称、或酒店地址中包含的关键字
    lat: '', // 百度纬度，searchType=3时，必传
    lon: '', // 百度经度，searchType=3时，必传
    onlySign: 0, // 是否仅查查询sign 1为是
    priceSourceType: null, // 上游协议价格来源 2线上协议
    priceRange: '', // 价格范围：不传代表不限；范围以-隔开；如果是150元以下，传0-150；如果是800元以上，传800-999999
    propertyIds: '', // 服务设施id，多个以逗号隔开
    facilitieNames: '', // 服务设施名称，多个以逗号隔开
    searchType: 0, // 查询类型，1 按行政区；2 按商圈；3 按经纬度；默认 0
    sort: 12, // 12按评分降序；21为星级升序，22为星级降序；31为价格升序，32为价格降序；41 距离升序。当searchType=3时，默认为41，其他情况默认 12
    starRate: '', // 挂牌星级：不限就不传；二星级以下,传2；三星传3；以此类推,多个以英文逗号隔开
    themes: '', // 酒店主题，多个用逗号隔开
    tripType: 1, // 差旅类型,1是因公,2是因私 因公时必填
    pageNum: 1,
    count: 20,
    hotelIds: '', // 签约酒店id
    cityName: '', // 城市名称
  }
}, {
  name: 'travelPolicyDetail',
  method: 'post',
  desc: '酒店差旅政策详情查询',
  path: '/obt/travelPolicyDetail',
  params: {
    cityId: '', // 城市等级代码
  },
  loading: '0'
}, {
  name: 'travelPolicy',
  method: 'post',
  desc: '酒店差旅政策详情查询',
  path: '/obt/jsClzcBzz',
  params: {
    cityId: '', // 城市Id
    corpId: '', // 企业Id
    sfpf: undefined, // 是否拼房
    rzrq: undefined, // 入住日期
    ldrq: undefined, // 离店日期
    roomList: undefined, // 房间集合
    /**
     * roomList: [
     *   { roomNo: 1, customerList: [HandOrderCustomerBean] }
     * ]
     *
     * HandOrderCustomerBean: {
     *   empDeptid (string, optional): 入住人所在的部门id ,
     *   empId (string, optional): 入住人id ,
     *   idNo (string, optional): 入住人证件号 ,
     *   psgName (string, optional): 入住人名称 ,
     *   psgPhone (string, optional): 入住人电话
     * }
     */
  },
  loading: '0'
}, {
  name: 'findGeoByCityId',
  method: 'get',
  desc: '酒店 -- 获取行政区、商区数据',
  path: '/obt/bdc/findGeoByCityId',
  params: {
    cityId: '', // 城市等级代码
    interfacePlatId: '' // 接口供应商标识
  }
}, {
  name: 'findJdStaticByCityIdData',
  method: 'post',
  desc: '酒店 -- 获取设施数据',
  path: '/obt/hotel/gn/shopping/findJdStaticByCityIdData',
  params: {
    cityId: '', // 城市等级代码
  }
}, {
  name: 'findJdStaticData',
  method: 'get',
  desc: '酒店 -- 获取星级、热门品牌数据',
  path: '/obt/bdc/findJdStaticData',
  params: {
    interfacePlatId: '',
    by5: '',
  }
}, {
  name: 'violateReasonList',
  method: 'get',
  desc: '酒店 -- 违背原因控件',
  path: '/obt/violateReasonList',
  params: {
    by1: '10903'
  }
}, {
  name: 'matchQuery',
  method: 'post',
  desc: '酒店 -- 服务费规则匹配查询',
  path: '/obt/hotel/set/fwf/matchQuery',
  params: {
    'corpId': '', // 企业ID，OBT无需传入。OSS后台查询时如果选择了企业，需传入。集中采购页面从需从订单上获取传入
    'roomCount': 0, // 房间数
    'cplx': '', // 产品类型编号，对应产品枚举编号，10903：国内酒店，10910：国际酒店
    'jgly': '', // 价格来源， 1：平台，2：代理自签 ，3：企业自签 ,
    'type': 0, // 因公因私，1：公 0：私 ,
    'fwfMatchList': [ // 每日房间费用集合
      {
        'date': '', // 日期
        'salePrice': 0 // 销售价
      }
    ]
  }
},

/**
 * 酒店询价单 : 酒店询价单
 */
{
  name: 'findHtNeedNote',
  method: 'post',
  desc: '酒店 -- 查询询价单签注',
  path: '/obt/findHtNeedNote',
  params: {
    orderId: '' // 询价单id
  }
},
{
  name: 'getHtNeedOrderDetail',
  method: 'post',
  desc: '酒店 -- 查询酒店询价单详情',
  path: '/obt/getHtNeedOrderDetail',
  params: {
    id: '' // 询价单id
  }
},
{
  name: 'hotelNeedOrderList',
  method: 'post',
  desc: '酒店 -- 查询询价单',
  path: '/obt/hotelNeedOrderList',
  params: {
    'cuId': null, // 查询用户Id
    'lookPriceDateEnd': '', // 询价日止
    'lookPriceDateStart': '', // 询价日始
    'pageNum': 1,
    'count': 20
  }
},
{
  name: 'saveNeedOrder',
  method: 'post',
  desc: '酒店 -- 保存询价单',
  path: '/obt/saveNeedOrder',
  params: {
    appId: '', // 审批规则ID
    bzbz: '', // 备注
    ccsqdId: '', // 出差申请单id
    ccsqdNo: '', // 出差单号
    cityId: '', // 城市id
    cityName: '', // 城市名称
    clbzj: 0, // 差旅标准价,单间夜
    content: '', // 备注内容
    costCenterCode: '', // 成本中心代码
    costCenterId: '', // 成本中心id
    costCenterName: '', // 成本中心名称
    expectBudget: 0, // 期望价格
    fxid: '', // 房型id
    fxmc: '', // 房型名称
    jdid: '', // 酒店id
    ldrq: '', // 离店日期
    linkEmail: '', // 联系人邮箱
    linkMobile: '', // 联系电话
    linkman: '', // 联系人
    nights: 0, // 晚数
    orderFrom: '', // 订单来源
    projectCode: '', // 出差项目代码
    projectId: '', // 出差项目ID
    projectName: '', // 出差项目名称
    rooms: 0, // 房间数
    rzrq: '', // 入住日期
    tripType: 1, // 出行类型,1是因公,2是因私
    vipStatus: '', // 差旅状态
    international: 1, // 国内国际,1是国内,0是国际 为空默认是国内
    singaZhid: '',
    platZhid: '',
    interfacePlatEnum: '',
  }
},
{
  name: 'savehtNeedNote',
  method: 'post',
  desc: '酒店 -- 保存询价单签注',
  path: '/obt/savehtNeedNote',
  params: {
    orderId: '', // 询价单id
    note: '' // 签注内容
  }
},

/**
 * 酒店shopping管理 : 酒店查询报价相关接口
 */
{
  name: 'keyword',
  method: 'post',
  desc: '酒店 -- 关键字补全',
  path: '/obt/hotel/gn/shopping/keyword',
  params: {
    cityId: '', // 城市id
    queryText: '', // 关键字
    gngj: '1', // 国内国际标识 1国内 0国际 默认国内
    mappingInterfacePlatId: '', // 酒店ID需要映射的目标供应商ID,不传默认是艺龙
    interfacePlatId: '',
    cityName: '', // 城市名称
  }
},
{
  name: 'hotelInfo',
  method: 'post',
  desc: '酒店 -- 基础资料',
  path: '/obt/hotel/gn/shopping/hotelInfo',
  params: {
    singaZhid: '',
    jdid: '', // 平台酒店id，列表查询返回的酒店ID
    interfacePlatEnum: '', // 接口供应商标识，列表查询返回的接口供应商标识
    international: 1,
    protocol: null
  }
},
{
  name: 'imgInfo',
  method: 'post',
  desc: '酒店 -- 酒店和房型图片信息',
  path: '/obt/hotel/gn/shopping/imgInfo',
  params: {
    singaZhid: '',
    platZhid: '',
    jdid: '', // 平台酒店id，列表查询返回的酒店ID
    interfacePlatEnum: '', // 接口供应商标识，列表查询返回的接口供应商标识
    fxid: '', // 供应商房型id，多个用逗号隔开
    imgSize: 1, // 图片尺寸：1:350350；2:7070；3:120120；4:640640；默认1
    imgType: '', // 图片类型：1餐厅；2休闲；3会议室；5外观；6大堂；8客房；10其他；11公共区域；12周边景点；多个用逗号隔开；
    protocol: null
  }
},
{
  name: 'roomInfo',
  method: 'post',
  desc: '酒店 -- 房型信息',
  path: '/obt/hotel/gn/shopping/roomInfo',
  params: {
    singaZhid: '',
    platZhid: '',
    checkInDate: '',
    checkOutDate: '',
    jdid: '', // 平台酒店id，列表查询返回的酒店ID
    interfacePlatEnum: '', // 接口供应商标识，列表查询返回的接口供应商标识
    roomId: '', // 供应商房型id
    sourceFrom: '', // 数据来源 传入1或空表示通过静态接口获取,2则通过动态接口查询
    protocol: null
  }
},
{
  name: 'pricePlanList',
  method: 'post',
  desc: '酒店 -- 酒店价格计划列表查询',
  path: '/obt/hotel/gn/shopping/pricePlanList',
  params: {
    singaZhid: '', // singa平台账号id
    searchPlatZhid: '', // 平台账号ID
    searchLocal: 1,
    hotelId: '', // 平台酒店id，列表查询返回的酒店ID
    interfacePlatEnum: '', // 接口供应商标识，列表查询返回的接口供应商标识
    checkInDate: '', // 入住日期：yyyy-mm-dd
    checkOutDate: '', // 离店日期：yyyy-mm-dd
    roomId: '', // 平台房型编号，传入时表示指定房型查询
    ratePlanId: '', // 价格计划id,重选日期的时候使用
    payment: '', // 支付方式：0到店付 1预付
    corpId: '', // 企业id,OSS选择企业后需传入，OBT可不传入
    tripType: 1, // 出差类型 1:因公 2因私，默认1
    protocol: null,
    hotelInterfaceBeans: null
  }
},
{
  name: 'pricePlanOne',
  method: 'post',
  desc: '酒店 -- 单个酒店价格计划查询',
  path: '/obt/hotel/gn/shopping/pricePlanOne',
  params: {
    singaZhid: '', // singa平台账号id
    searchPlatZhid: '', // 平台账号ID
    searchLocal: 1,
    hotelId: '', // 平台酒店id，列表查询返回的酒店ID
    interfacePlatEnum: '', // 接口供应商标识，列表查询返回的接口供应商标识
    checkInDate: '', // 入住日期：yyyy-mm-dd
    checkOutDate: '', // 离店日期：yyyy-mm-dd
    roomId: '', // 平台房型编号，传入时表示指定房型查询
    ratePlanId: '', // 价格计划id,重选日期的时候使用
    payment: '', // 支付方式：0到店付 1预付
    corpId: '', // 企业id,OSS选择企业后需传入，OBT可不传入
    tripType: 1 // 出差类型 1:因公 2因私，默认1
  }
},
{
  name: 'priceValidate',
  method: 'post',
  desc: '酒店 -- 房型最新价格校验',
  path: '/obt/hotel/gn/shopping/priceValidate',
  params: {
    singaZhid: '', // singa平台账号id
    searchPlatZhid: '', // 平台账号ID
    searchLocal: 1,
    cityId: '',
    hotelId: '', // 平台酒店id，列表查询返回的酒店ID
    interfacePlatEnum: '', // 接口供应商标识，列表查询返回的接口供应商标识
    checkInDate: '', // 入住日期：yyyy-mm-dd
    checkOutDate: '', // 离店日期：yyyy-mm-dd
    roomId: '', // 平台房型编号，传入时表示指定房型查询
    ratePlanId: '', // 价格计划id,重选日期的时候使用
    payment: '', // 支付方式：0到店付 1预付
    corpId: '', // 企业id,OSS选择企业后需传入，OBT可不传入
    tripType: 1, // 出差类型 1:因公 2因私，默认1
    protocol: null
  }
},
{
  name: 'getSignJdCity',
  method: 'post',
  desc: '酒店 -- 签约酒店城市列表',
  path: '/obt/hotel/gn/shopping/getSignJdCity',
  params: {}
},

/**
 * 酒店正常单管理 : 酒店正常单管理(下单以及正常单相关操作)
 */
{
  name: 'book',
  method: 'post',
  desc: '酒店 -- 酒店正常单下单',
  path: '/obt/hotel/order/book',
  params: {
    'singaZhid': '', // singa平台账号id
    'platZhid': '', // 平台账号ID
    'cityId': '',
    'interfacePlatEnum': '',
    'hotelId': '',
    'roomId': '',
    'ratePlanId': '',
    'checkInDate': '',
    'checkOutDate': '',
    'payment': 0,
    // 'earliestArrivalTime': '',
    'latestArrivalTime': '',
    'subjectCode': '',
    'ifSameOrder': '',
    'noteToHotel': '',
    'sfpf': undefined,
    'orderRooms': [
      {
        'customers': [
          {
            'clbzj': 0,
            'email': '',
            'empDeptId': '',
            'empId': '',
            'fsEmpId': '',
            'gender': '',
            'idCardNo': '',
            'mobile': '',
            'name': '',
            'nationality': '',
            'phone': ''
          }
        ],
        'roomNo': 0
      }
    ],
    'linkman': '',
    'linkMobile': '',
    'tripType': 1,
    'linkEmail': '',
    'creditCard': undefined,
    'travelInfo': {
      'ccsqdId': '',
      'ccsqdNo': '',
      'ccsqdRemark': '',
      'corpCode': '',
      'corpId': '',
      'corpName': '',
      'costCenterCode': '',
      'costCenterId': '',
      'costCenterName': '',
      'ifSameOrder': '',
      'projectCode': '',
      'projectId': '',
      'projectName': '',
      'reasonCode': '',
      'reasonDesc': '',
      'routeId': '',
      'subjectCode': '',
      'tripType': 1,
      'violateitem': '',
      'violateitemCode': ''
    },
    'orderFrom': '',
    'protocol': null
    // 'sendMode': 0,
    // 'recipient': '',
    // 'reciPhone': '',
    // 'reciEmail': '',
    // 'reciPostCode': '',
    // 'reciAddr': '',
    // 'postCode': '',
    // 'psyqsj': '',
    // 'postMothed': '',
    // 'fyid': '',
    // 'isNeedInvoice': '',
    // 'invoice': {
    // 	'amount': '',
    // 	'itemName': '',
    // 	'recipient': {},
    // 	'title': ''
    // },
    // 'fyl': 0,
    // 'recommender': '',
    // 'recommenderName': '',
    // 'corpBookerId': ''
  }
},
{
  name: 'guarantee',
  method: 'post',
  desc: '酒店 -- 酒店下单担保',
  path: '/obt/hotel/order/guarantee',
  params: {
    'singaZhid': '', // singa平台账号id
    'platZhid': '', // 平台账号ID
    'hotelId': '', // 酒店id
    'interfacePlatEnum': '', // 接口供应商标识
    'roomId': '', // 房型编码，本地房型
    'ratePlanId': '', // 价格计划id
    'checkInDate': '', // 入住日期：yyyy-mm-dd
    'checkOutDate': '', // 离店日期：yyyy-mm-dd
    'latestArrivalTime': '', // 最晚到店时间 HH:mm
    'numberOfRooms': 0 // 房间数量
  }
},
{
  name: 'creditcardValidate',
  method: 'post',
  desc: '酒店 -- 酒店下单信用卡校验',
  path: '/obt/hotel/order/creditcardValidate',
  params: {
    'singaZhid': '', // singa平台账号id
    'platZhid': '', // 平台账号ID
    'international': '',
    'creditCardNumber': '',
    'interfacePlatEnum': ''
  }
},
{
  name: 'editCreditcard',
  method: 'post',
  desc: '酒店 -- 酒店下单信用卡信息修改',
  path: '/obt/hotel/order/editCreditcard',
  params: {
    'orderId': '', // 订单ID,如果表中存在该记录则修改，否则添加
    'number': '', // 卡号；若需要修改则传入,无需加密,后台处理
    'cvv': '', // cvv；若需要修改则传入,无需加密,后台处理
    'expirationYear': '', // 有效期-年 yyyy；若需要修改则传入
    'expirationMonth': '', // 有效期-月 mm；若需要修改则传入
    'holderName': '', // 持卡人；若需要修改则传入
    'idType': '', // 证件类型。身份证 1， 护照 2，军人证 3， 其他 4；若需要修改则传入
    'cardType': '', // 信用卡类型；若需要修改则传入
    'idNo': '', // 证件号码；若需要修改则传入,无需加密,后台处理
    'tel': '', // 持卡人手机；若需要修改则传入
    'dbJe': 0 // 担保金额
  }
},
{
  name: 'queryCreditcard',
  method: 'post',
  desc: '酒店 -- 酒店下单信用卡信息查询',
  path: '/obt/hotel/order/queryCreditcard',
  params: {
    'orderId': '', // 订单ID
  }
},

/**
 * 酒店订单管理 : 酒店订单管理
 */
{
  name: 'hotelOrderDetail',
  method: 'get',
  desc: '酒店 -- 酒店订单详情',
  path: '/obt/hotelOrderDetail',
  params: {
    orderId: '' // 酒店订单id
  }
},
{
  name: 'hotelOrderCancel',
  method: 'post',
  desc: '酒店 -- 订单取消',
  path: '/obt/hotelOrderCancel',
  params: {
    orderId: '', // 酒店订单id
    orderFrom: '' // 订单来源
  }
},

/**
 * 酒店退单 : 酒店退单
 */
{
  name: 'applyHotelRefund',
  method: 'post',
  desc: '酒店 -- 申请退房',
  path: '/obt/applyHotelRefund',
  params: {
    orderId: '' // 酒店订单id
  }
},
{
  name: 'hotelRefundAdd',
  method: 'post',
  desc: '酒店 -- 生成退单',
  path: '/obt/hotelRefundAdd',
  params: {
    orderId: '', // 酒店订单id
    orderFrom: '', // 订单来源
    orderPrices: '', // 订单价格ids
    vipRefundReason: '' // 企业退房理由
  }
},
{
  name: 'hotelRefundCancel',
  method: 'post',
  desc: '酒店 -- 退单取消',
  path: '/obt/hotelRefundCancel',
  params: {
    hotelRefundId: '', // 退单id
    orderFrom: '', // 订单来源
    version: '', // 订单版本号
  }
},
{
  name: 'hotelRefundDetail',
  method: 'post',
  desc: '酒店 -- 退单详',
  path: '/obt/hotelRefundDetail',
  params: {
    hotelRefundId: '', // 退单id
  }
},
{
  name: 'hotelRefundList',
  method: 'post',
  desc: '酒店 -- 退单列表',
  path: '/obt/hotelRefundList',
  params: {
    orderId: '', // 酒店订单id
  }
},
/**
 * 获取进度
 */
{
  name: 'vipOrderAppProgress',
  method: 'post',
  desc: '获取进度',
  path: '/obt/vipOrderAppProgress',
  params: {
    orderId: '',
    orderType: ''
  }
},
{
  name: 'getOpenPlat',
  method: 'post',
  desc: '查询所有开放的在线接口平台',
  path: '/obt/hotel/gn/shopping/getOpenPlat',
  params: {
    corpId: undefined,
    jkShbh: undefined
  }
}

]

